import { useLocation } from 'react-router-dom';
import { useState } from "react";
import { styled } from '@mui/material/styles';
import { Grid, AppBar, Toolbar, Divider, useMediaQuery, Drawer, IconButton, Stack, Box } from '@mui/material';
import { bgBlur } from '../../../utils/cssStyles';
import CustomTabs from './CustomTabs';
import { Logo } from '../../../reusable-components/logo';
import { ScopeGuard } from '../../../reusable-components/scopes';
import HeaderItems from './HeaderItems';
import MobileHeader from "./MobileHeader";
import Iconify from '../../../reusable-components/iconify';
import NewTicket from './NewOrderAndTicket/NewTicket';
import NewMenu from './NewOrderAndTicket/NewMenu';
import OrderRentalGlobalCart from './OrderRentalGlobalCart'
import SiteSwitch from './SiteSwitch';
import AccountPopover from './AccountPopover';
import NotificationsSummary from './NotificationsSummary';
import MobileNewOrderAndTicket from './NewOrderAndTicket/MobileNewOrderAndTicket';

export default function Header() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { pathname } = useLocation();
  const checkPath = (path) => pathname.includes(`/dashboard/${path}`);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);


  // const handleGoBack = () => {
  //   navigate(-1); // Go back to the previous page
  // };
   const logoMargin = 12;
  const logoWidth = 120;

  return (
    <StyledRoot>
      {!isMobile && <CustomTabs />}
      {isMobile && <Drawer open={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)}>
        <MobileHeader
          setIsMobileNavOpen={setIsMobileNavOpen}
          checkPath={checkPath}
        />
      </Drawer>}
      <StyledToolbar>
        <Grid
          container
          justifyContent="flex-start"
          spacing={1}
        >
          <Grid item xs={isMobile ? 6 : 1} sx={{display: isMobile ? 'flex' : 'inherit'}}>
            {isMobile && <IconButton onClick={() => setIsMobileNavOpen(true)}>
              <Iconify icon="mdi:menu"/>
            </IconButton>}
            <Logo
              width={logoWidth}
              sx={{
                mr: 1.5,
                mt: 1,
                bgcolor: 'transparent',
              }}
              
            />
          </Grid>
          <Grid item xs={isMobile ? 6 : 11} sx={{display: 'flex', alignItems: 'center'}}>
            {!isMobile && <HeaderItems/>}
            <Box sx={{ flexGrow: 1 }} />
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              spacing={{ xs: 0.5, sm: 1 }}
            >
              {' '}
              {isMobile ? <MobileNewOrderAndTicket /> : <>
                <NewTicket />
                <NewMenu />
              </>}
              <NotificationsSummary />
              {/* <NotificationsPopover /> */}
              <ScopeGuard scopes={['View-Order', 'Rental-Order-View']} allowAdmin>
                <OrderRentalGlobalCart />
              </ScopeGuard>
              {!isMobile && <ScopeGuard scopes={['Super-Admin']}>
                <SiteSwitch />
              </ScopeGuard>}
              <AccountPopover />
            </Stack>
          </Grid>
        </Grid>
      </StyledToolbar>
      {!isMobile && <>
        <Divider
          sx={{
            ml: `${logoWidth + logoMargin + xPadding + toolbarItemLeftMargin}px`,
            mr: `${xMargin + xPadding}px`,
            height: '5px',
            opacity: 0.39,
            backgroundImage: `linear-gradient(269deg, #8dc63f 50%, #707070)`,
          }}
        />
      </>
      }
    </StyledRoot>
  );
}

const xMargin = 18;
const xPadding = 24;
const toolbarItemLeftMargin = 16;
const headerHeightMobile = 56;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default, opacity: 1 }),
  
  boxShadow: 'none',
  width: '100%',
  position: "sticky",
  [theme.breakpoints.down('md')]: {
    backgroundColor: 'white'
  }
}));

const StyledToolbar = styled(Toolbar)(() => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return {
    maxHeight: isMobile ? headerHeightMobile : 92,
    marginLeft: isMobile ? 0 : `${xMargin}px`,
    marginRight: isMobile ? 0 : `${xMargin}px`
  }
});